// Mock datasets for charts, stats, and tables (frontend-only demos)
export const mockLine = [
  { x: '2024-01', y: 35000 },
  { x: '2024-02', y: 37000 },
  { x: '2024-03', y: 39000 },
  { x: '2024-04', y: 41000 },
  { x: '2024-05', y: 44500 },
  { x: '2024-06', y: 47000 },
];

export const mockBar = [
  { category: 'Housing', value: 1800 },
  { category: 'Food', value: 650 },
  { category: 'Transport', value: 420 },
  { category: 'Entertainment', value: 280 },
  { category: 'Other', value: 350 },
];

export const mockPie = [
  { id: 'Stocks', label: 'Stocks', value: 55 },
  { id: 'Bonds', label: 'Bonds', value: 20 },
  { id: 'Cash', label: 'Cash', value: 15 },
  { id: 'Alts', label: 'Alts', value: 10 },
];

export const mockBullet = [
  {
    id: 'Goal',
    ranges: [0, 25, 50, 75, 100],
    measures: [68],
    markers: [85],
  },
];

export const mockStats = [
  { label: 'Net Worth', value: '$47,200', delta: '+12%', trendDirection: 'up' },
  { label: 'Monthly Cash Flow', value: '+$1,150', delta: 'Stable', trendDirection: 'flat' },
  { label: 'Total Debt', value: '$11,800', delta: '-6%', trendDirection: 'down' },
];

export const mockTable = {
  columns: [
    { key: 'name', label: 'Account' },
    { key: 'balance', label: 'Balance' },
    { key: 'change', label: 'Change' },
  ],
  rows: [
    { name: 'Checking', balance: '$4,200', change: '+$150' },
    { name: 'Brokerage', balance: '$22,500', change: '+$620' },
    { name: '401k', balance: '$38,000', change: '+$1,100' },
  ],
};

export const mockQuickActions = [
  { label: 'Find spending leaks', text: 'Where can I cut back this month without feeling it?' },
  { label: 'Reach my savings goal', text: 'Help me build a realistic plan to hit my savings goal.' },
  { label: 'Reduce my debt', text: 'What is the smartest way for me to pay down debt?' },
  { label: 'Review my money plan', text: 'What should I focus on next across spending, saving, and investing?' },
];
